"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("../../styles/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var icon = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
var styles = {
  root: {
    minWidth: '50px',
    height: function height(_ref) {
      var uncontained = _ref.uncontained;
      return uncontained ? '100%' : '';
    },
    width: function width(_ref2) {
      var uncontained = _ref2.uncontained;
      return uncontained ? '100%' : '';
    }
  },
  inputContainer: {
    position: 'relative',
    width: '100%',
    height: function height(_ref3) {
      var uncontained = _ref3.uncontained,
          isTextArea = _ref3.isTextArea;
      if (uncontained || isTextArea) return '100%';
      return '35px';
    }
  },
  leftIcon: {
    extend: icon,
    left: 0,
    padding: function padding(_ref4) {
      var uncontained = _ref4.uncontained;
      return uncontained ? '20px' : '15px';
    }
  },
  rightIcon: {
    extend: icon,
    right: 0,
    padding: function padding(_ref5) {
      var uncontained = _ref5.uncontained;
      return uncontained ? '20px' : '15px';
    }
  },
  input: {
    height: '100%',
    width: function width(_ref6) {
      var uncontained = _ref6.uncontained,
          isTextArea = _ref6.isTextArea;
      if (isTextArea && !uncontained) return 'auto';
      return '100%';
    },
    outline: 'none',
    transition: 'all 0.3s',
    resize: 'none',
    fontSize: function fontSize(_ref7) {
      var uncontained = _ref7.uncontained;
      return uncontained ? '16px' : '12px';
    },
    borderRadius: function borderRadius(_ref8) {
      var uncontained = _ref8.uncontained;
      return uncontained ? 0 : '3px';
    },
    border: function border(_ref9) {
      var uncontained = _ref9.uncontained;
      return uncontained ? 'none' : '1px solid';
    },
    borderColor: function borderColor(_ref10) {
      var showError = _ref10.showError;
      return showError ? _colors["default"].red : _colors["default"].sterling;
    },
    borderBottom: function borderBottom(_ref11) {
      var uncontained = _ref11.uncontained,
          showError = _ref11.showError;
      if (uncontained) return "2px solid ".concat(showError ? _colors["default"].red : _colors["default"].white);
      return '';
    },
    padding: function padding(_ref12) {
      var leftIcon = _ref12.leftIcon,
          rightIcon = _ref12.rightIcon,
          uncontained = _ref12.uncontained,
          isTextArea = _ref12.isTextArea;
      var defaultPadding = uncontained || isTextArea ? 20 : 10;
      if (leftIcon && rightIcon) return "".concat(defaultPadding, "px 50px");
      if (leftIcon) return "".concat(defaultPadding, "px ").concat(defaultPadding, "px ").concat(defaultPadding, "px 50px");
      if (rightIcon) return "".concat(defaultPadding, "px 50px ").concat(defaultPadding, "px ").concat(defaultPadding, "px");
      return "".concat(defaultPadding, "px");
    },
    backgroundColor: function backgroundColor(_ref13) {
      var showError = _ref13.showError,
          disabled = _ref13.disabled;

      if (showError) {
        return _colors["default"].redLightest;
      }

      if (disabled) {
        return _colors["default"].heather;
      }

      return _colors["default"].white;
    },
    '&:focus': {
      borderColor: function borderColor(_ref14) {
        var showError = _ref14.showError;
        return showError ? _colors["default"].red : _colors["default"].blue;
      },
      backgroundColor: _colors["default"].white,
      '&::placeholder': {
        color: 'transparent'
      }
    },
    '&::-ms-clear': {
      display: 'none'
    }
  },
  inputActive: {
    borderColor: function borderColor(_ref15) {
      var showError = _ref15.showError;

      if (showError) {
        return _colors["default"].red;
      }

      return _colors["default"].blue;
    },
    backgroundColor: _colors["default"].white
  },
  errorText: {
    color: _colors["default"].red,
    fontSize: '12px',
    marginTop: '5px'
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  }
};
var _default = styles;
exports["default"] = _default;